export default {
  path: '/v5/academy',
  name: 'V5_academy',
  component: () => import('./AcademyPage.vue'),
};
